import React from 'react';
import styled from 'styled-components';

import { Grid } from '@/ui/Grid/atoms';
import { JourneyPageWrapper } from '@/features/journey/admin/pages/JourneyPageWrapper';

const List = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap || 0}px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

type StartLayoutProps = {
  headerStart?: React.ReactNode;
  headerEnd?: React.ReactNode;
  hero: React.ReactNode;
  main: React.ReactNode;
  sidebar: React.ReactNode;
};

export const StartLayout = ({ main, sidebar, hero, headerStart, headerEnd }: StartLayoutProps): JSX.Element => {
  return (
    <JourneyPageWrapper>
      <List gap={16}>
        {(headerStart || headerEnd) && (
          <Header>
            <div>{headerStart}</div>
            <div>{headerEnd}</div>
          </Header>
        )}
        {hero}
      </List>
      <Grid rowGap="medium">
        <Grid.Item mobile={12} mobileLandscape={12} tablet={12} desktop={8} desktopLarge={8} widescreen={8} fullHD={8}>
          <List gap={24}>{main}</List>
        </Grid.Item>
        <Grid.Item mobile={12} mobileLandscape={12} tablet={12} desktop={4} desktopLarge={4} widescreen={4} fullHD={4}>
          <List gap={24}>{sidebar}</List>
        </Grid.Item>
      </Grid>
    </JourneyPageWrapper>
  );
};
